import { CustomerFormView } from '@today/ui-domain'
import { LanguageSelector } from '@/components/LanguageSelector'
import { useCustomerForm } from '@/hooks/customers/useCustomerForm'

/** `/customers/new` and `/customers/:id/edit` (TO-418 customer-ui REQ-005). */
export function CustomerFormPage() {
	const form = useCustomerForm()
	return (
		<div className="flex flex-col gap-4 p-6">
			<LanguageSelector />
			<CustomerFormView {...form} />
		</div>
	)
}
